<template>
  <!-- 分组 -->
  <div class="box-main">
    <div class="main">
      <div>
        <div class="main-title">分组</div>
      </div>
      <div class="main-center h72">
        <v-button class="" type="primary" name="" @click="showNewGroupModel"
          >创建分组</v-button
        >
        <v-form ref="form" :model="ruleForm" :rules="rules" class="searchform ml10">
          <v-form-item prop="searchData" :required="false" >
            <v-input
            v-model="ruleForm.searchData"
            placeholder="请输入分组名称"
          ></v-input>
          </v-form-item>
        </v-form>
        <v-button class="ml10" type="primary" name="" @click="handleSearch">查询</v-button>
        <v-button class="" type="info" name="" @click="clear">重置</v-button>

      </div>
      <div>
        <vxe-table
          row-id="id"
          :data="table"
          align="left"
          :row-style="setRowClass"
        >
          <vxe-table-column
            field="group_name"
            show-overflow
            min-width="120"
            title="分组名称"
          ></vxe-table-column>
          <!-- <vxe-table-column
            field="group_sort"
            show-overflow
            min-width="120"
            title="分组排序"
          ></vxe-table-column> -->
          <vxe-table-column
            field="group_desc"
            show-overflow
            min-width="120"
            title="描述"
          ></vxe-table-column>
          <vxe-table-column
            field="created_at_str"
            show-overflow
            min-width="120"
            title="创建时间"
          ></vxe-table-column>
          <vxe-table-column
            field="updated_at_str"
            show-overflow
            min-width="120"
            title="更新时间"
          ></vxe-table-column>
          <vxe-column title="操作" min-width="140">
            <template v-slot="slotProps">
              <span class="handle-button"
                ><v-button
                  size="S"
                  type="text"
                  name="btn1"
                  slot="reference"
                  @click="openViewModel(slotProps.row)"
                  >查看</v-button
                ></span
              >
              <span class="handle-button"
                ><v-button
                  size="S"
                  type="text"
                  name="btn1"
                  slot="reference"
                  @click="showUpdataDevModel(slotProps.row)"
                  >编辑</v-button
                ></span
              >
              <span class="handle-button"
                ><v-button
                  size="S"
                  type="text"
                  name="btn2"
                  slot="reference"
                  @click="showDelModel(slotProps.row)"
                  >删除</v-button
                ></span
              >
            </template>
          </vxe-column>
        </vxe-table>
      </div>
      <v-pagination
        v-if="total"
        @change-page="changePage"
        @change-size="changeSize"
        :total="total"
        name="page-basic"
        is-show-total
        is-change-size
        is-input-page
        :current-page="this.currentPage"
      ></v-pagination>
    </div>

    <NewGroup
      :showInputDialog.sync="NewGrouploading"
      ref="NewGroup"
      @getData="getData"
    ></NewGroup>
    <Del
      :showInputDialog.sync="Delloading"
      ref="Del"
      :groupId="groupId"
      @getData="getData"
    ></Del>
    <UpdataGroup
      :showInputDialog.sync="UpdataGrouploading"
      :infoData="infoData"
      @getData="getData"
      ref="UpdataGroup"
    ></UpdataGroup>
  </div>
</template>

<script>
import NewGroup from "@/components/group/new-group.vue";
import Del from "@/components/group/del.vue";
import { copy } from '@/common/libs/utils';
import UpdataGroup from "@/components/group/updata-group.vue";

export default {
  components: { NewGroup, Del, UpdataGroup },
  data() {
    return {
      ruleForm:{
        searchData:''
      },
      rules: {
        searchData: copy([{
          type: "inputNameInput"
        }])
      },
      NewGrouploading: false,
      UpdataGrouploading: false,
      Delloading: false,
      currentPage: 1,
      infoData: {},
      pageSize: 10,
      table: [],
      groupId: "",
      total: 0,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    setRowClass({ rowIndex }) {
      if (rowIndex % 2 !== 0) {
        return "background: #fafafa";
      }
    },
    clear () {
      this.ruleForm.searchData = ''
      this.changePage(1)
    },
    handleSearch () {
      const valid = this.$refs.form.submitForm();
        if (valid === false) {
          return;
        }
      this.changePage(1)
    },
    async getData() {
      const subData = {
        app_id: sessionStorage.getItem("appid") || "",
        page_num: this.currentPage,
        page_size: this.pageSize,
        group_name: this.ruleForm.searchData,
      };
      const res = await this.$post(
        "/td/td-iot-api/iot/group/page/v1",
        subData,
        false
      );
      if (res.code === 0) {
        this.table = res.data.list;
        this.total = res.data.page.total;
      } else {
        if (res.code == "100410") {
          setTimeout(() => {
            this.getData();
          }, 1000);
        } else {
          this.$message.error(res.msg);
        }
      }
    },
    changePage(page) {
      this.currentPage = Number(page);
      this.getData();
    },
    changeSize(size) {
      this.pageSize = Number(size);
      this.currentPage = 1
      this.getData();
    },
    showNewGroupModel() {
      this.NewGrouploading = !this.NewGrouploading;
    },
    showDelModel(row) {
      this.groupId = row.id;
      this.Delloading = !this.Delloading;
    },
    showUpdataDevModel(row) {
      this.infoData = row;
      this.UpdataGrouploading = !this.UpdataGrouploading;
    },
    openViewModel(row) {
      //跳转路由
      this.$router.push({
        name: "/deviceInfo-manage/subgroup-details-info",
        query: { id: row.id, name: row.group_name },
      });
    },
  },
  beforeDestroy() {},
};
</script>
<style lang="scss">
.low-title {
  font-size: 18px;
}
</style>
